export const PRODUCT_PAGE_SIZE = 60;
export const CATALOG_PAGE_SIZE = 20;
